<template>
  <transition name="van-fade">
    <div v-show="show" class="tips-container flex">
      <div class="tips">
        <van-icon v-if="types[type].icon !== ''" class="icon" :name="types[type].icon" :color="types[type].color" />
        <div class="text" :style="{ color: types[type].color }">{{ text }}</div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { defineProps } from 'vue'

defineProps({
  show: {
    type: Boolean,
    default: false
  },
  text: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'default'
  }
})
const types = {
  default: {
    icon: '',
    color: '#333333'
  },
  success: {
    icon: 'passed',
    color: '#4fc08d'
  },
  warning: {
    icon: 'bulb-o',
    color: '#ff976a'
  },
  danger: {
    icon: 'close',
    color: '#ee0a24'
  }
}

</script>

<style lang="scss" scoped>
.tips-container {
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: white;
  &.flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .tips {
    text-align: center;
    .text {
      font-size: 20px;
      margin-top: 12px;
    }
  }
}
</style>
